<div *ngIf="loanStatus">
    <app-page-meta pageTitle="finzy - Loan Details"></app-page-meta>
    <app-header></app-header>
    <div class="container-fluid">
        <div class="row">
            <app-investormenu></app-investormenu>

            <div class="col-xs-12 col-md-10 col-lg-11 main-content"
                 *ngIf="!isLoanClosed(loanStatus) && !isLoanReversed(investedAmount)">

                <div class="row finzy-breadcrumbs-row">
                    <p class="breadcrumbs-finzy"><a class="bread" (click)="goToBread()">{{portfolioName}}</a> &nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;
                        Loan Details</p>
                </div>

                <div class="row finzy-row5">
                    <p class="finzy-t1">LOAN DETAILS</p>
                    <p [ngStyle]="{'color':loanStatus === 'Sub Standard Asset' || loanStatus === 'Loss Asset'? '#f65a41':'' }"
                       class="finzy-t2">{{loanStatus}}</p>
                    <p class="finzy-txt-ps72">
                        <span class="dark"><span *ngIf="loan.loanRestructuredOn">ORIGINAL </span>RATING : </span>
                        <!-- <span class="finzy-color">{{generated_loan_id}}</span> -->
                        <span class="A1">&nbsp;&nbsp;{{rating}}&nbsp;&nbsp;</span>
                        <span class="dark"><span *ngIf="loan.loanRestructuredOn">RESTRUCTURED </span>ROI : </span>
                        <span class="dark">&nbsp;&nbsp;{{roi}}%&nbsp;&nbsp;</span>
                        <span class="dark"> LOAN ID: </span>
                        <span class="dark">&nbsp;&nbsp;{{generatedLoanId}}&nbsp;&nbsp;</span></p>

                    <div class="row finzy-row32">
                        <div class="col-sm-4">
                            <p class="finzy-txt-ps7">LOAN AMOUNT</p>
                            <p class="finzy-p8"><span class="rupees">₹ </span> {{loanAmount | number : fractionSize}}
                            </p>
                            <hr class="hr-finzy2">
                        </div>
                        <div class="col-sm-4">
                            <p class="finzy-txt-ps7">AMOUNT INVESTED</p>
                            <p class="finzy-p8"><span
                                    class="rupees">₹ </span> {{investedAmount | number : fractionSize}}</p>
                            <hr class="hr-finzy2">
                        </div>
                        <div class="col-sm-4">
                            <p class="finzy-txt-ps7">EARNED AMOUNT</p>
                            <p class="finzy-p8"><span class="rupees">₹ </span> {{ repaidAmount | number : fractionSize}}
                            </p>
                            <hr class="hr-finzy2">
                        </div>
                    </div>

                    <div class="row finzy-row10">
                        <mat-tab-group>
                            <mat-tab *ngIf="isWrittenOff(loanStatus)" label="Write-off Details">
                                <app-write-off
                                        [investedAmount]="investedAmount" [emiSchedule]="emiSchedule"
                                        [lenderShare]="lenderShare" [prepaymentDetails]="prepaymentDetails"
                                        [lendersInvested]="lendersInvested"
                                        [loanId]="loanId"
                                        [loanSanctionStatus]="loanSanctionStatus"
                                ></app-write-off>
                            </mat-tab>
                            <mat-tab *ngIf="!isSettledAndClosed(loanStatus) && !isWrittenOff(loanStatus)" label="{{getEmiScheduleLabel()}}">
                                <div *ngIf="hasUpcomingEmis">
                                    <mat-table #table [dataSource]="dataSource" matSort>

                                        <ng-container matColumnDef="due_on">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> Date
                                            </mat-header-cell>
                                            <mat-cell
                                                    *matCellDef="let element"> {{element.dueOn | dateFormat}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="payable_amount">
                                            <mat-header-cell *matHeaderCellDef> EMI</mat-header-cell>
                                            <mat-cell *matCellDef="let element">
                                                ₹ {{element.payableAmount}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="remaining_tenure">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> Tenure Balance
                                            </mat-header-cell>
                                            <mat-cell
                                                    *matCellDef="let element"> {{element.remainingTenure + 1}}</mat-cell>
                                        </ng-container>

                                        <ng-container matColumnDef="emi_status">
                                            <mat-header-cell *matHeaderCellDef mat-sort-header> EMI Status
                                            </mat-header-cell>
                                            <mat-cell
                                                    *matCellDef="let element"> {{element.emiStatus}}</mat-cell>
                                        </ng-container>

                                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                    </mat-table>

                                    <mat-paginator #paginator [length]="5"
                                                   [pageSize]="5"
                                                   [pageSizeOptions]="[5, 10, 20]">
                                    </mat-paginator>
                                </div>
                                <div class="errorp" *ngIf="!hasUpcomingEmis">No upcoming EMIs to display</div>
                            </mat-tab>
                            <mat-tab *ngIf="loan.loanRestructuredOn" label="Restructuring Details">
                                <app-restructured-loan-detail
                                        [loan]="loan"
                                        [lenderShare]="lenderShare"
                                ></app-restructured-loan-detail>
                            </mat-tab>
                            <mat-tab label="Loan Documents">
                                <div class="errorp" *ngIf="!doc_length">No loan documents to display</div>
                                <div class="row finzy-row3" *ngIf="doc_length">
                                    <div class="col-sm-8">
                                        <div class="row">
                                            <div class="col-sm-2"><span class="downloadImg"><i class="fa fa-file-text-o"
                                                                                               aria-hidden="true"></i></span>
                                            </div>
                                            <div class="col-sm-10">
                                                <p class="finzy-p71">Contract</p>
                                                <p class="finzy-p81">A contract safeguards interests of both the
                                                    parties</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-4">
                                        <div class="downloadDiv">
                                            <a href="{{contract}}" (click)="openFromMobile($event,true)" target="_blank" class="downloadanc"><p
                                                    class="download"><i
                                                    class="material-icons downloadmat">file_download</i></p>
                                                <p class="finzy-proi2">&nbsp;&nbsp; DOWNLOAD</p></a>
                                        </div>
                                    </div>
                                </div>

                            </mat-tab>
                        </mat-tab-group>


                    </div>

                </div>


                <div class="row finzy-row4">
                    <p class="finzy-p6">If you need assistance you can find help here <a target="_blank"
                                                                                         [routerLink]="['/faq']"
                                                                                         class="finzy-col">FAQs</a>. You
                        could
                        even
                        call us on 9341 300 300. We are always happy to help!</p>
                </div>

            </div>
            <div *ngIf="isLoanClosed(loanStatus) || isLoanReversed(investedAmount)">
                <div class="row alignDivCenter">
                    <div class="alignImage">
                        <img src="../../assets/images/group-10.svg">
                    </div>
                    <p class="finzy-t1">
                        Loan details not available
                    </p>
                    <p class="subheading">You cannot view the details of the loan. This loan was either closed before
                        disbursal
                        or the investment into the loan was reversed by you.
                    </p>
                    <button [routerLink]="['/investordashboard']" mat-flat-button class="dashboardButton primary">
                        Dashboard
                    </button>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>
